export default {
  initCombos() {
    $(".select2").select2({
      placeholder: "Seleccionar...",
      allowClear: true
    });
  },

  initIndex() {
    this.initCombos();

    FormHelper.handleSearch();
    FormHelper.handleOrderBy();
    FormHelper.handleImports();
  },

  /**
   * Elimina un registro a través de un POST
   *
   * @param {Object} form Formulario que elimina el registro a través de la acción configurada
   * @param {String} numero Nombre del registro a eliminar
   */
  eliminar(form, numero) {
    let mensaje =
      "<p>¿Realmente deseas eliminar la Cuenta Nº <strong>" +
      numero +
      "</strong>?</p><p>La acci&oacute;n no podr&aacute; ser revertida.</p>";
    FormHelper.confirm(form, mensaje);
  }
};
